import { observable, action, runInAction, makeObservable } from 'mobx'
import { dataStore } from '../UIStore'
import { FieldTypeOptions } from '../../components/RightSideBar/information/FieldTypeSelect'

// State for the "Manage additional fields" modal (ManageFieldsContent). Owned by ManageModalStore.
// The fields themselves live in dataStore.userAdditionalInfoItems so the Additional Information
// sidebar stays in sync; this store only holds the modal's form and dialog state.
class FieldsModalStore {
  @observable saving = false
  @observable deleteItem = null
  @observable newType = FieldTypeOptions[0].type
  @observable newName = ''
  @observable newCurrency = 'USD'

  constructor () {
    makeObservable(this)
  }

  get selectedType () {
    return FieldTypeOptions.find(option => option.type === this.newType)
  }

  @action setNewType (type) { this.newType = type }
  @action setNewName (name) { this.newName = name }
  @action setNewCurrency (currency) { this.newCurrency = currency }
  @action setDeleteItem (item) { this.deleteItem = item }

  @action open () {
    this.newType = FieldTypeOptions[0].type
    this.newName = ''
    this.newCurrency = 'USD'
    this.deleteItem = null
  }

  async addField () {
    const title = this.newName.trim()
    if (!title || this.saving) return
    const option = this.selectedType
    const input = { ...option.input, title }
    if (option.type === 'currency') input.currency = this.newCurrency
    runInAction(() => { this.saving = true })
    const created = await dataStore.saveUserAdditionalInfoItem({
      label: option.label,
      type: option.type,
      input
    })
    runInAction(() => {
      this.saving = false
      if (created) this.newName = ''
    })
  }

  async confirmDelete () {
    if (!this.deleteItem || this.saving) return
    runInAction(() => { this.saving = true })
    await dataStore.deleteUserAdditionalInfoItem(this.deleteItem.id)
    runInAction(() => {
      this.saving = false
      this.deleteItem = null
    })
  }
}

export default FieldsModalStore
